// @ts-nocheck

// This file was generated by [tauri-specta](https://github.com/oscartbeaumont/tauri-specta). Do not edit this file manually.

/** user-defined commands **/

export const commands = {
  async getEvent(id: string): Promise<Event | null> {
    return await TAURI_INVOKE("plugin:db|get_event", { id });
  },
  async listEvents(filter: ListEventFilter | null): Promise<Event[]> {
    return await TAURI_INVOKE("plugin:db|list_events", { filter });
  },
  async upsertEvent(event: Event): Promise<Event> {
    return await TAURI_INVOKE("plugin:db|upsert_event", { event });
  },
  async deleteEvent(id: string): Promise<null> {
    return await TAURI_INVOKE("plugin:db|delete_event", { id });
  },
  async getCalendar(calendarId: string): Promise<Calendar> {
    return await TAURI_INVOKE("plugin:db|get_calendar", { calendarId });
  },
  async listCalendars(userId: string): Promise<Calendar[]> {
    return await TAURI_INVOKE("plugin:db|list_calendars", { userId });
  },
  async upsertCalendar(calendar: Calendar): Promise<Calendar> {
    return await TAURI_INVOKE("plugin:db|upsert_calendar", { calendar });
  },
  async toggleCalendarSelected(trackingId: string): Promise<Calendar> {
    return await TAURI_INVOKE("plugin:db|toggle_calendar_selected", { trackingId });
  },
  async upsertSession(session: Session): Promise<Session> {
    return await TAURI_INVOKE("plugin:db|upsert_session", { session });
  },
  async visitSession(id: string): Promise<null> {
    return await TAURI_INVOKE("plugin:db|visit_session", { id });
  },
  async onboardingSessionId(): Promise<string> {
    return await TAURI_INVOKE("plugin:db|onboarding_session_id");
  },
  async listSessions(filter: ListSessionFilter | null): Promise<Session[]> {
    return await TAURI_INVOKE("plugin:db|list_sessions", { filter });
  },
  async deleteSession(id: string): Promise<null> {
    return await TAURI_INVOKE("plugin:db|delete_session", { id });
  },
  async getSession(filter: GetSessionFilter): Promise<Session | null> {
    return await TAURI_INVOKE("plugin:db|get_session", { filter });
  },
  async setSessionEvent(sessionId: string, eventId: string): Promise<null> {
    return await TAURI_INVOKE("plugin:db|set_session_event", { sessionId, eventId });
  },
  async sessionAddParticipant(sessionId: string, humanId: string): Promise<null> {
    return await TAURI_INVOKE("plugin:db|session_add_participant", { sessionId, humanId });
  },
  async sessionRemoveParticipant(sessionId: string, humanId: string): Promise<null> {
    return await TAURI_INVOKE("plugin:db|session_remove_participant", { sessionId, humanId });
  },
  async sessionListParticipants(sessionId: string): Promise<Human[]> {
    return await TAURI_INVOKE("plugin:db|session_list_participants", { sessionId });
  },
  async sessionGetEvent(sessionId: string): Promise<Event | null> {
    return await TAURI_INVOKE("plugin:db|session_get_event", { sessionId });
  },
  async getTimelineView(sessionId: string): Promise<TimelineView | null> {
    return await TAURI_INVOKE("plugin:db|get_timeline_view", { sessionId });
  },
  async getTimelineViewOnboarding(): Promise<TimelineView> {
    return await TAURI_INVOKE("plugin:db|get_timeline_view_onboarding");
  },
  async getConfig(): Promise<Config> {
    return await TAURI_INVOKE("plugin:db|get_config");
  },
  async setConfig(config: Config): Promise<null> {
    return await TAURI_INVOKE("plugin:db|set_config", { config });
  },
  async getExtensionMapping(userId: string, extensionId: string): Promise<ExtensionMapping | null> {
    return await TAURI_INVOKE("plugin:db|get_extension_mapping", { userId, extensionId });
  },
  async listExtensionMappings(userId: string): Promise<ExtensionMapping[]> {
    return await TAURI_INVOKE("plugin:db|list_extension_mappings", { userId });
  },
  async upsertExtensionMapping(mapping: ExtensionMapping): Promise<ExtensionMapping> {
    return await TAURI_INVOKE("plugin:db|upsert_extension_mapping", { mapping });
  }
};

/** user-defined types **/

export type Calendar = { id: string; tracking_id: string; user_id: string; platform: Platform; name: string; selected: boolean; source: string | null }
export type Config = { id: string; user_id: string; general: ConfigGeneral; notification: ConfigNotification; ai: ConfigAI }
export type ConfigAI = { api_base: string | null; api_key: string | null }
export type ConfigGeneral = { autostart: boolean; display_language: string; jargons: string[]; telemetry_consent: boolean; save_recordings: boolean | null }
export type ConfigNotification = { before: boolean; auto: boolean; ignoredPlatforms: string[] | null }
export type ConversationChunk = { start: string; end: string; transcripts: TranscriptChunk[]; diarizations: DiarizationChunk[] }
export type DiarizationChunk = { start: number; end: number; speaker: number; confidence: number | null }
export type Event = { id: string; user_id: string; tracking_id: string; calendar_id: string | null; name: string; note: string; start_date: string; end_date: string; google_event_url: string | null }
export type ExtensionDefinition = { id: string; title: string; description: string; implemented: boolean; default: boolean; cloud_only: boolean; plugins: string[]; tags: string[] }
export type ExtensionMapping = { id: string; user_id: string; extension_id: string; config: JsonValue; widgets: ExtensionWidget[] }
export type ExtensionWidget = { kind: ExtensionWidgetKind; group: string; position: ExtensionWidgetPosition | null }
export type ExtensionWidgetKind = "oneByOne" | "twoByOne" | "twoByTwo" | "full"
export type ExtensionWidgetPosition = { x: number; y: number }
export type GetSessionFilter = { id: string } | { calendarEventId: string } | { tagId: string }
export type Human = { id: string; organization_id: string | null; is_user: boolean; full_name: string | null; email: string | null; job_title: string | null; linkedin_username: string | null }
export type JsonValue = null | boolean | number | string | JsonValue[] | Partial<{ [key in string]: JsonValue }>
export type ListEventFilter = ({ user_id: string; limit: number | null }) & ({ type: "simple" } | { type: "search"; query: string } | { type: "dateRange"; start: string; end: string })
export type ListSessionFilter = ({ user_id: string; limit: number | null }) & ({ type: "search"; query: string } | { type: "recentlyVisited" } | { type: "dateRange"; start: string; end: string })
export type Platform = "Apple" | "Google" | "Outlook"
export type Session = { id: string; created_at: string; visited_at: string; user_id: string; calendar_event_id: string | null; title: string; raw_memo_html: string; enhanced_memo_html: string | null; conversations: ConversationChunk[] }
export type TimelineView = { items: TimelineViewItem[] }
export type TimelineViewItem = { start: number; end: number; speaker: number; text: string; confidence: number }
export type TranscriptChunk = { start: number; end: number; text: string; confidence: number | null }

/** tauri-specta globals **/

import {
  invoke as TAURI_INVOKE,
} from "@tauri-apps/api/core";